import { render, staticRenderFns } from "./WorkDistributionDeleteDialog.vue?vue&type=template&id=15a93814"
import script from "./WorkDistributionDeleteDialog.vue?vue&type=script&lang=js"
export * from "./WorkDistributionDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports